import { useRef } from 'react';
import { useLocation, useRouteMatch } from 'react-router';
import { startCase } from 'lodash';
import { useHandleModuleNavigation } from 'hooks';
import { ReportDashboard } from 'modules/campaigns/modules/campaigns-reports';
import * as reportConfigIndex from 'modules/campaigns/modules/campaigns-reports/config/reports/reportConfigIndex';
import useReportConfigMap from 'modules/campaigns/modules/campaigns-reports/config/reports/useReportConfigMap';
import { MODULE_NAME } from 'modules/push-api/config/routes';
import { ReportHeader } from '../../campaigns/components/ReportHeader/ReportHeader';
import { StaticIndications } from '../../taboola-common-frontend-modules/Indications';
import { useIntl } from '../../taboola-common-frontend-modules/i18n';
import { EmptyPushApiReport } from '../components/EmptyPushApiReport/EmptyPushApiReport';
import { PushApiEditDrawer } from '../components/PushApiEditDrawer/PushApiEditDrawer';
import styles from './pushApiPage.module.scss';

export const PushApiPage = () => {
    const location = useLocation();
    const containerRef = useRef();
    const { state } = location;
    const match = useRouteMatch(null);

    const handleNavigation = useHandleModuleNavigation({ path: match.path });

    const reportConfigMap = useReportConfigMap(reportConfigIndex);

    const { formatMessage } = useIntl();
    const title = formatMessage({
        id: 'app.campaigns.reports.datagrid.overlay.push-api.header',
        defaultMessage: 'API Integrations',
    });

    const buildReportNameForExport = selectedReport => ` - ${startCase(selectedReport)} API Integrations`;

    return (
        <div className={styles['container']} ref={containerRef}>
            <StaticIndications />
            <ReportDashboard
                skipFetchReport={state && state.skipFetchReport}
                parentContainerRef={containerRef}
                module={MODULE_NAME}
                header={<ReportHeader title={title} />}
                rangePickerPresetConfigs={{}}
                buildReportNameForExport={buildReportNameForExport}
                reportConfigMap={reportConfigMap}
                closeSideDrawer={handleNavigation}
                EmptyStateComponent={EmptyPushApiReport}
            />
            <PushApiEditDrawer onCancel={handleNavigation} />
        </div>
    );
};
